export const recordAgreement = (api, userId, document, version) => api.rpc('service-terms', '1/2018-05-18/record_agreement', { userId, document, version });
export const latestDocuments = (api) => api.rpc('service-terms', '1/2018-05-18/get_latest_documents', void 0);
export const userStatus = (api, userId) => api.rpc('service-terms', '1/2018-05-18/get_user_status', { userId });
